import { ConfigOrderDetails, MapOrderDetails, Section } from '../types';

function formatSection(section: Section): MapOrderDetails[] {
  const { shouldExport, fields } = section;

  if (!shouldExport || !Array.isArray(fields)) {
    return [];
  }

  return fields.map((field) => ({
    label: field.title,
    value: field.value?.label ?? ''
  }));
}

function formatConfigToMap(orderConfig: ConfigOrderDetails): MapOrderDetails[] {
  let listMapOrderDetails: MapOrderDetails[] = [];
  orderConfig.sections.forEach((section) => {
    listMapOrderDetails = listMapOrderDetails.concat(formatSection(section));
  });
  return listMapOrderDetails;
}

export default formatConfigToMap;
